'use client'

import React from 'react'
import { Tab } from '@headlessui/react'
import { Body } from "../Body"
import classNames from "classnames";


interface TabProp {
    label: string
    content?: {
        processed: string
    }
    node?: React.ReactNode
}

interface TabsProps {
    tabs: TabProp[]
}

export default function Tabs({tabs}: TabsProps) {
  
  return (
    <div className="w-full my-4">
      <Tab.Group>
        <Tab.List className="flex rounded-xl p-1 gap-4 bg-navy-800/30">
          {tabs.map((t) => (
            <Tab
              key={t.label}
              className={({ selected }) =>
                classNames(
                  'rounded-xl p-4 flex-grow shadow font-medium text-lg hover:shadow-inner leading-5',
                  // 'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                  'ring-white/60 ring-offset-2 ring-offset-navy-600/60 focus:outline-none focus:ring-2',
                  selected
                    ? 'bg-white text-navy-600 shadow'
                    : 'text-gray-800 hover:bg-white/60 text-white hover:text-navy-600'
                )
              }
            >
              {t.label}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="mt-2">
          {tabs.map((t:TabProp, idx) => (
            <Tab.Panel
              key={idx}
              className={classNames(
                'rounded-xl bg-white p-3',
                'ring-white/60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2'
              )}
            >
             { t.content != null ? (
                <Body value={t.content.processed} />
              ) : t.node }
              
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  )
}
